'use client';

import React from 'react';

import NewsletterPreferencesView from '@/components/newsletter/NewsletterPreferencesView';
import NewsletterRegistrationView from '@/components/newsletter/NewsletterRegistrationView';

import { useNewsletterModal } from '@/providers/NewsletterModalProvider';

/**
 * Cineamo newsletter page. Replaces the modal-driven manage view. Branches by
 * subscriber status:
 *   - confirmed → grouped toggle preferences (Figma "Newsletter Preferences" mockup)
 *   - pending / expired / not subscribed → dark-themed signup form
 *     ("Newsletter Registration" mockup)
 */
export default function CineamoNewsletterClient() {
    const { subscriberStatus } = useNewsletterModal();

    const isConfirmed = subscriberStatus?.subscribed === true && subscriberStatus?.doiStatus === 'confirmed';

    return (
        <main className="min-h-screen">
            {isConfirmed ? (
                <NewsletterPreferencesView subscriberStatus={subscriberStatus} />
            ) : (
                // The footer link and direct links land here, and the ticket's stated exception is
                // that those may pre-select everything (CIN-13995). Passed explicitly so the
                // default is visible at the call site rather than buried in the view.
                <NewsletterRegistrationView topicPreselection="all" />
            )}
        </main>
    );
}
